import 'tslib';
import * as Long from 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import { Conversation } from '../../core/model/Conversation.js';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import { ConversationCoreInfo } from '../../core/model/ConversationCoreInfo.js';
import { ConversationSettingInfo } from '../../core/model/ConversationSettingInfo.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class ConversationStore {
    static toStore(c) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const s = new ConversationStore();
        s.coreInfo = {
            conversationId: c.coreInfo.conversationId,
            version: (_a = c.coreInfo.version) === null || _a === void 0 ? void 0 : _a.toString(),
            name: c.coreInfo.name,
            desc: c.coreInfo.desc,
            icon: c.coreInfo.icon,
            notice: c.coreInfo.notice,
            owner: c.coreInfo.owner,
            secOwner: c.coreInfo.secOwner,
            innerExt: c.coreInfo.ext,
            inboxType: c.coreInfo.inboxType
        };
        s.firstPageParticipant = {
            cursor: (_c = (_b = c.firstPageParticipant) === null || _b === void 0 ? void 0 : _b.cursor) === null || _c === void 0 ? void 0 : _c.toString(),
            hasMore: (_d = c.firstPageParticipant) === null || _d === void 0 ? void 0 : _d.has_more,
            participants: (_f = (_e = c.firstPageParticipant) === null || _e === void 0 ? void 0 : _e.participants) === null || _f === void 0 ? void 0 : _f.map(p => {
                var _a, _b, _c;
                return ({
                    userId: (_a = p.user_id) === null || _a === void 0 ? void 0 : _a.toString(),
                    secUid: p.sec_uid,
                    sortOrder: (_b = p.sort_order) === null || _b === void 0 ? void 0 : _b.toString(),
                    role: p.role,
                    alias: p.alias,
                    blocked: p.blocked,
                    leftBlockTime: (_c = p.left_block_time) === null || _c === void 0 ? void 0 : _c.toString()
                });
            })
        };
        s.id = c.id;
        s.isMember = c.isMember;
        s.isOffline = c.isOffline;
        s.participantCount = c.participantCount;
        s.settingInfo = {
            conversationId: c.settingInfo.conversationId,
            version: (_g = c.settingInfo.version) === null || _g === void 0 ? void 0 : _g.toString(),
            stickTop: c.settingInfo.stickTop,
            mute: c.settingInfo.mute,
            favor: c.settingInfo.favor,
            innerExt: c.settingInfo.ext,
            minIndex: (_h = c.settingInfo.minIndex) === null || _h === void 0 ? void 0 : _h.toString(),
            readIndex: (_j = c.settingInfo.readIndex) === null || _j === void 0 ? void 0 : _j.toString(),
            setTopTime: (_k = c.settingInfo.setTopTime) === null || _k === void 0 ? void 0 : _k.toString(),
            setFavoriteTime: (_l = c.settingInfo.setFavoriteTime) === null || _l === void 0 ? void 0 : _l.toString(),
            pushStatus: c.settingInfo.pushStatus
        };
        s.shortId = c.shortId;
        s.ticket = c.ticket;
        s.type = c.bizType;
        return s;
    }
    static fromStore(ctx, s) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const c = new Conversation(ctx); // bind later
        const coreInfo = new ConversationCoreInfo(c);
        coreInfo.version = Long.fromValue((_b = (_a = s.coreInfo) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : 0);
        coreInfo.name = s.coreInfo.name;
        coreInfo.desc = s.coreInfo.desc;
        coreInfo.icon = s.coreInfo.icon;
        coreInfo.notice = s.coreInfo.notice;
        coreInfo.owner = s.coreInfo.owner;
        coreInfo.secOwner = s.coreInfo.secOwner;
        coreInfo.ext = s.coreInfo.innerExt;
        coreInfo.inboxType = s.coreInfo.inboxType;
        const settingInfo = new ConversationSettingInfo(c);
        settingInfo.version = Long.fromValue((_d = (_c = s.settingInfo) === null || _c === void 0 ? void 0 : _c.version) !== null && _d !== void 0 ? _d : 0);
        settingInfo.stickTop = s.settingInfo.stickTop;
        settingInfo.mute = s.settingInfo.mute;
        settingInfo.favor = s.settingInfo.favor;
        settingInfo.ext = s.settingInfo.innerExt;
        settingInfo.readIndex = Long.fromValue((_e = s.settingInfo.readIndex) !== null && _e !== void 0 ? _e : 0);
        settingInfo.minIndex = Long.fromValue((_f = s.settingInfo.minIndex) !== null && _f !== void 0 ? _f : 0);
        settingInfo.setTopTime = Long.fromValue((_g = s.settingInfo.setTopTime) !== null && _g !== void 0 ? _g : 0);
        settingInfo.setFavoriteTime = Long.fromValue((_h = s.settingInfo.setFavoriteTime) !== null && _h !== void 0 ? _h : 0);
        settingInfo.pushStatus = s.settingInfo.pushStatus;
        c.coreInfo = coreInfo;
        c.settingInfo = settingInfo;
        c.firstPageParticipant = im_proto.ParticipantsPage.create({
            cursor: ((_j = s.firstPageParticipant) === null || _j === void 0 ? void 0 : _j.cursor) ? Long.fromValue(s.firstPageParticipant.cursor) : undefined,
            has_more: (_k = s.firstPageParticipant) === null || _k === void 0 ? void 0 : _k.hasMore,
            participants: (_m = (_l = s.firstPageParticipant) === null || _l === void 0 ? void 0 : _l.participants) === null || _m === void 0 ? void 0 : _m.map(p => ({
                user_id: p.userId ? Long.fromValue(p.userId) : undefined,
                sec_uid: p.secUid,
                sort_order: p.sortOrder ? Long.fromValue(p.sortOrder) : undefined,
                role: p.role,
                alias: p.alias,
                blocked: p.blocked,
                left_block_time: p.leftBlockTime ? Long.fromValue(p.leftBlockTime) : undefined
            }))
        });
        c.id = s.id;
        c.isMember = s.isMember;
        c.isOffline = s.isOffline;
        c.participantCount = s.participantCount;
        c.shortId = s.shortId;
        c.ticket = s.ticket;
        c.bizType = s.type;
        return c;
    }
}

export { ConversationStore };
//# sourceMappingURL=ConversationStore.js.map
